import { GasTravel } from './gas-travel';
export class InvoiceTicket{
    id: number = 0;
    invoice_number: string = "";
    iva: number = 0.0;
    subtotal: number = 0.0;
    total: number = 0.0;
    status: string = '';
    gastickets: GasTravel[] = [];
}